import { NgModule } from '@angular/core';
import { ApproximateRoundCountPipe } from './approximate-round-count.pipe';

@NgModule({
    declarations: [ApproximateRoundCountPipe],
    exports: [ApproximateRoundCountPipe],
})
export class ApproximateRoundCountModule {}
